import React, { useRef, useState } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import { FAQS } from '../data';
import './FAQSection.css';

function FAQItem({ faq, isOpen, onToggle }) {
  return (
    <div className={`faq-item${isOpen ? ' faq-item--open' : ''}`}>
      <button className="faq-item__question" onClick={onToggle} aria-expanded={isOpen}>
        <span className="faq-item__question-text">{faq.question}</span>
        <span className="faq-item__icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d={isOpen ? 'M4 9h10' : 'M9 4v10M4 9h10'}
              stroke="#8B0000"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="faq-item__answer">
          <p>{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQSection() {
  const ref = useRef(null);
  const visible = useIntersection(ref);
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="faq" ref={ref} id="faq">
      <div className="container">
        <div className={`faq__inner${visible ? ' visible' : ''}`}>
          <div className="faq__header">
            <h2 className="faq__title">Frequently Asked Questions</h2>
            <div className="gold-divider" />
          </div>
          <div className="faq__list">
            {FAQS.map((faq) => (
              <FAQItem
                key={faq.id}
                faq={faq}
                isOpen={openId === faq.id}
                onToggle={() => toggle(faq.id)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
